<script setup lang="ts">
    import {
        ICoachingFormAnswer,
        ICoachingFormQuestion,
    } from '@/js/services/api/coachingForm/types';
    import EditCoachingFormAnswerOptions from './EditCoachingFormAnswerOptions.vue';
    import { onMounted, watch } from 'vue';
    import { temporaryUUID } from '@/js/composables/useTemporaryUUID';
    import { __ } from '@/js/stores/expressions';

    const question = defineModel<ICoachingFormQuestion>('question', { required: true });

    onMounted(() => {
        if (!question.value.interval) {
            question.value.interval = { from: 1, to: 5, step: 1 };
        }
    });

    watch(
        () => [question.value.interval],
        () => {
            if (
                question.value.interval?.from !== null &&
                question.value.interval?.to !== null &&
                question.value.interval?.step !== null
            ) {
                const answers: ICoachingFormAnswer[] = [];
                const from = parseInt(String(question.value.interval?.from));
                const to = parseInt(String(question.value.interval?.to));
                const step = parseInt(String(question.value.interval?.step)) || 1;

                for (let i = from; i <= to; i += step) {
                    answers.push({
                        id: temporaryUUID(),
                        label: String(i),
                        points: i,
                    });
                }

                question.value.answers = answers;
            }
        },
        { immediate: true, deep: true }
    );
</script>

<template>
    <div v-if="question.interval" class="flex gap-6 mt-5">
        <div>
            <label :for="'points-interval-from' + question.id" class="block text-overline mb-1">
                {{ __('points-range') }}
            </label>
            <div class="flex gap-2">
                <input
                    :id="'points-interval-from' + question.id"
                    v-model="question.interval.from"
                    type="tel"
                    class="TextInput w-16 text-center"
                />
                <input
                    :id="'points-interval-to' + question.id"
                    v-model="question.interval.to"
                    type="tel"
                    class="TextInput w-16 text-center"
                />
            </div>
        </div>
        <div>
            <label :for="'points-interval-step' + question.id" class="block text-overline mb-1">
                {{ __('step') }}
            </label>
            <input
                :id="'points-interval-step' + question.id"
                v-model="question.interval.step"
                type="tel"
                class="TextInput w-16 text-center"
            />
        </div>
    </div>

    <fieldset class="block mt-6">
        <EditCoachingFormAnswerOptions :question="question" />
    </fieldset>
</template>
